<template>
    <div id="debugcncpage">
        <ui5-button id="cancelDebugCnc" @click="$router.push('/debugmenu')">
            {{ trans('pages.debug_cnc.back') }}
        </ui5-button>
        <ui5-button @click="loadCnc">{{ trans('pages.debug_cnc.refresh') }}</ui5-button>
        <div id="debugcnc" />
    </div>
</template>
<script>
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    mounted() {
        this.loadCnc();
    },
    methods: {
        loadCnc() {},
    },
};
</script>
